import { options } from "jodit/esm/core/helpers";
import { useGetLmsMilestoneList, useGetLmsSessionList, useGetLmsSprintList } from "../../../assets/api/useAdminApi";
import { useAllVoiceGet, useGetAllLmsCourses, useGetLmsBoards, useGetLmsChapters, useGetLmsGrades, useGetLmsLangauge, useGetLmsPublications, useGetLmsSubject, useGetLmsTags, useGetLmsTopics, useGetSessionListByCourseId } from "../../../assets/nodeApi/getApi/getAdminApi";


export const useLmsDropdownOptions = ({ courseId, tagFilter, subjectFilter, gradeFilter, milestoneFilter, sprintFilter, session1Filter, boardFilter, charpterFilter, topicFilter, mode, courseFilter, ThreejsFilter } = {}) => {


    const { data: lmsGradeList, isLoading: isLmsGradeLoading } = useGetLmsGrades(gradeFilter);
    const { data: lmsBoardList, isLoading: isLmsBoardLoading } = useGetLmsBoards(boardFilter);
    const { data: lmsPublicationList, isLoading: isLmsPublicationLoading } = useGetLmsPublications();
    const { data: lmsLangaugeList, isLoading: isLmsLangaugeLoading } = useGetLmsLangauge();
    const { data: lmsSessionList, isLoading: islmsSessionLoading } = useGetSessionListByCourseId(courseId)
    // const { data: lmsCourseList, isLoading: islmsCoursesLoading } = useGetAllLmsCourses()
    const { data: lmsCourseList, isLoading: islmsCoursesLoading } = useGetAllLmsCourses({ lms: true, ...courseFilter });
    const { data: lmsSubjectList, isLoading: isLmsSubjectLoading } = useGetLmsSubject(subjectFilter)
    const { data: lmsTagList, isLoading: isLmsTagLoading } = useGetLmsTags(tagFilter)
    const { data: lmsChapterList, isLoading: isLmsChapterLoading } = useGetLmsChapters(charpterFilter)
    const { data: lmsTopicList, isLoading: isLmsTopicLoading } = useGetLmsTopics(topicFilter)
    const { data: lmsMilestoneList, isLoading: isLmsMilestoneListLoading } = useGetLmsMilestoneList(milestoneFilter)
    const { data: lmsSprintList, isLoading: isLmsSprintLoading } = useGetLmsSprintList(sprintFilter)
    const { data: lmsSessionList1, isLoading: isLmsSessionList1Loading } = useGetLmsSessionList(session1Filter)


    const { data: lmsCourseListThreejs, isLoading: isLmsCourseOptionsThreejs } = useAllVoiceGet(ThreejsFilter)


    const lmsGradeOptions =
        lmsGradeList?.data?.map((item, index) => ({
            id: item.id,
            label: item.name,
            value: item.name,
            sr_no: index + 1,
            ...item
        })) ?? [];

    const lmsSessionOptions =
        lmsSessionList?.sessions?.map((item, index) => ({
            id: item.sessionId,
            label: item.sessionName,
            value: item.sessionName,
            sr_no: index + 1,
            ...item
        })) ?? [];

    const lmsBaordOptions =
        lmsBoardList?.map((item, index) => ({
            id: item.id,
            label: item.name,
            value: item.name,
            sr_no: index + 1,
            ...item
        })) ?? [];

    const lmsPublicationOptions =
        lmsPublicationList?.map((item, index) => ({
            id: item.id,
            label: item.name,
            value: item.name,
            sr_no: index + 1,
            ...item
        })) ?? [];

    const lmsLangaugeOptions =
        lmsLangaugeList?.languages?.map((item, index) => ({
            id: item.id,
            label: item.name,
            value: item.name,
            sr_no: index + 1,
            ...item
        })) ?? [];
    const lmsCoursesOptions =
        lmsCourseList?.map((item, index) => ({
            id: item.id,
            label: item.title,
            value: item.title,
            sr_no: index + 1,
            ...item
        })) ?? [];

    const lmsCourseOptionsThreejs =
        lmsCourseListThreejs?.courses?.map((item, index) => ({
            id: item.id,
            label: item.name || "No Name",
            value: item.id,
            sr_no: index + 1,
            ...item,
        })) ?? [];


    const lmsSubjectOptions =
        lmsSubjectList?.data?.map((item, index) => ({
            id: item.id,
            label: item.subject,
            value: item.subject,
            sr_no: index + 1,
            ...item
        })) ?? [];


    const lmsTagOptions =
        lmsTagList?.data?.map((item, index) => ({
            id: item.id,
            label: item.tag,
            value: item.tag,
            sr_no: index + 1,
            ...item
        })) ?? [];
    const lmsChapterOptions =
        lmsChapterList?.data?.map((item, index) => ({
            id: item.id,
            label: item.name,
            value: item.name,
            sr_no: index + 1,
            ...item
        })) ?? [];

    const lmsTopicOptions =
        lmsTopicList?.data?.map((item, index) => ({
            id: item.id,
            label: item.name,
            value: item.name,
            sr_no: index + 1,
            ...item
        })) ?? [];


    const lmsMilestoneOptions =
        lmsMilestoneList?.milestone?.map((item, index) => ({
            id: item.id,
            label: item.name,
            value: item.name,
            sr_no: index + 1,
            ...item
        })) ?? [];
    const lmsSprintOption =
        lmsSprintList?.sprint?.map((item, index) => ({
            id: item.id,
            label: item.name,
            value: item.name,
            sr_no: index + 1,
            ...item
        })) ?? [];
    const
        lmsSession1Option =
            lmsSessionList1?.session?.map((item, index) => ({
                id: item.id,
                label: item.sessionname,
                value: item.sessionname,
                sr_no: index + 1,
                ...item
            })) ?? [];

    const lmsQuestionSourceOption = [
        {
            id: 1,
            label: "Teacher to Student",
            value: "teacher_to_student",
        },
        {
            id: 2,
            label: "Student to Teacher",
            value: "student_to_teacher",
        },
    ];

    const lmsQuestionTypeOption = [
        {
            id: 1,
            label: "Descriptive",
            value: "Descriptive",
        },
        {
            id: 2,
            label: "Objective",
            value: "Objective",
        },
    ];
    const courseTypeOptions = [
        { id: 7, label: "Skill 2 Skool", value: "S2S" },
        { id: 8, label: "Upskill 4 Teachers", value: "U4T" },
        { id: 9, label: "CAMPS", value: "CAMPS" },
        { id: 10, label: "TTT", value: "TTT" },
    ]

    const lmsDifficultyLevelOption = [
        {
            id: 1,
            label: "Easy",
            value: "Easy",
        },
        {
            id: 2,
            label: "Medium",
            value: "Medium",
        },
        {
            id: 3,
            label: "Hard",
            value: "Hard",
        },
    ];
    const lmsCourseTypeOption = [
        {
            id: 1,
            label: "Basic LMS",
            value: "Basic_LMS",
        },
        {
            id: 2,
            label: "AI Tutor",
            value: "AI_Tutor",
        },
        {
            id: 3,
            label: "3D Class",
            value: "ThreeD_Class",
        },
    ];
    const lmsParagraLanguageOption = [
        { id: 1, value: 'en', label: 'EN' },
        { id: 2, value: 'hi', label: 'HI' },
        { id: 3, value: 'te', label: 'TE' },
        { id: 4, value: 'kn', label: 'KN' },
        { id: 5, value: 'ml', label: 'ML' },
        { id: 6, value: 'ta', label: 'TA' }
    ]

    const CourseLevelOption = [
        { id: 1, label: "Beginner", value: "beginner" },
        { id: 2, label: "Intermediate", value: "intermediate" },
        { id: 3, label: "Expert", value: "expert" },
    ]


    return {

        lmsGrade: {
            options: lmsGradeOptions,
            isLoading: isLmsGradeLoading,
        },
        lmsSession: {
            options: lmsSessionOptions,
            isLoading: islmsSessionLoading,
        },
        lmsBoard: {
            options: lmsBaordOptions,
            isLoading: isLmsBoardLoading,
        },
        lmsPublication: {
            options: lmsPublicationOptions,
            isLoading: isLmsPublicationLoading,
        },
        lmsLangauge: {
            options: lmsLangaugeOptions,
            isLoading: isLmsLangaugeLoading,
        },
        lmsDifficultyLevel: {
            options: lmsDifficultyLevelOption,
        },
        lmsQuestionSource: {
            options: lmsQuestionSourceOption,
        },
        lmsQuestionType: {
            options: lmsQuestionTypeOption,
        },
        lmsCourseTypeOptions: {
            options: courseTypeOptions
        },
        lmsCourses: {
            options: lmsCoursesOptions,
            isLoading: islmsCoursesLoading
        },
        lmsDifficultyLevelOption: {

        },
        lmsCourseType: {
            options: lmsCourseTypeOption,
        },
        lmsParagraLanguage: {
            options: lmsParagraLanguageOption
        },

        lmsQuestionTypeOptionThreejs: {
            options: lmsQuestionTypeOption
        },
        lmsQuestionSourceOptionThreejs: {
            options: lmsQuestionSourceOption
        },

        lmsSubject: {
            options: lmsSubjectOptions,
            isLoading: isLmsSubjectLoading,
        },

        lmsTag: {
            options: lmsTagOptions,
            isLoading: isLmsTagLoading,
        },
        lmsChapter: {
            options: lmsChapterOptions,
            isLoading: isLmsChapterLoading,
        },
        lmsTopic: {
            options: lmsTopicOptions,
            isLoading: isLmsTopicLoading,
        },

        lmsMilestone: {
            options: lmsMilestoneOptions,
            isLoading: isLmsMilestoneListLoading,
        },

        lmsSprint: {
            options: lmsSprintOption,
            isLoading: isLmsSprintLoading,
        },

        lmsSession1: {
            options: lmsSession1Option,
            isLoading: isLmsSessionList1Loading,
        },
        CourseLevelOption: {
            options: CourseLevelOption
        },
        DificultyLevelOptions: {
            options: lmsDifficultyLevelOption
        },
        ThreejsViewOptions: {
            options: lmsCourseOptionsThreejs,
            isLoading: isLmsCourseOptionsThreejs
        }
    };
};